<template>
    <div>
        <Navigation/>

        <Sidebar></Sidebar>
        <div class="mt-3 mb-3 main">  
            <div class="">
                <slot></slot>
            </div>
        </div>
        <!-- <Footer v-if="!hideFooter"/> -->
    </div>
</template>
<script>
import Navigation from '@/components/layout/Navigation'
import Footer from '@/components/layout/Footer'
import Sidebar from '@/components/layout/Sidebar'

export default {
    name:"Layout",
    props:{
        pageTitle: { default: ''},
        pageSubtitle: { default: ''},
        hideFooter: { default: false},
    },
    components:{
		Navigation,
		Footer,	
        Sidebar,
	},
}
</script>

<style scoped>
.main{
    width: calc(100% - 280px);
    margin-left: 280px;
    padding: 0px 16px;
}
.main-container{
    padding: 18px;
}

@media (max-width: 991px) {
    .main{
        width: calc(100% - 64px);
        margin-left: 64px;
    }
}
@media (max-width: 576px) {
    .main{
        width: 100%;
        margin-left: 0px;
    }
}
</style>